import type { GridFilterModel, GridSortModel } from "@mui/x-data-grid-premium";
import { ResourceEnum } from "src/constants/constants.ts";
import type {
  CreateStockMoveFormMeta,
  CreateVariantFormMeta,
} from "src/framework/types.ts";

export type ListQueryKeyParams = {
  page?: {
    number: number;
    size: number;
  };
  isInfinite?: boolean;
  include?: string[];
  locale?: string;
  groupKeys?: string[];
  paginationMode?: "simple";
  option?: string;
  filter?: GridFilterModel;
  sort?: GridSortModel;
  resource: string;
};

export const createModuleQueries = () => {
  const queries = {
    all: ({ resource }: { resource: string }) => [resource] as const,
    list: ({
      option = "default",
      locale,
      resource,
      isInfinite = false,
      ...restParams
    }: ListQueryKeyParams) => {
      return [
        ...queries.lists({ resource }),
        isInfinite ? "infinite" : "finite",
        option,
        { params: restParams },
        locale,
      ] as const;
    },
    lists: ({ resource }: { resource: string }) =>
      [...queries.all({ resource }), "list"] as const,
    details: ({ resource }: { resource: string }) =>
      [...queries.all({ resource }), "detail"] as const,
    detail: (params: {
      id: string;
      locale?: string;
      resource: string;
      include?: string[];
      meta?: any;
    }) => {
      const { resource, id, locale, include } = params;
      if (!locale) {
        return [
          ...queries.details({ resource }),
          id,
          ...(include ? [include] : []),
        ] as const;
      }
      return [
        ...queries.details({
          resource,
        }),
        id,
        locale,
        ...(include ? [include] : []),
      ] as const;
    },
    allCreateForms: ({ resource }: { resource: string }) => {
      return [...queries.all({ resource }), "createForm"];
    },
    createFormData: ({
      resource,
      locale,
      meta,
    }: {
      resource: string;
      locale?: string;
      meta?: any;
    }) => {
      if (resource === ResourceEnum.StockMove && meta) {
        return [
          ...queries.allCreateForms({ resource }),
          "variant",
          (meta as CreateStockMoveFormMeta).variantSku,
          "data",
          locale,
        ];
      }
      if (resource === ResourceEnum.Variant && meta) {
        return [
          ...queries.allCreateForms({ resource }),
          "product",
          (meta as CreateVariantFormMeta).product_id,
          "data",
          locale,
        ];
      }

      if (!locale) {
        return [...queries.allCreateForms({ resource }), "data"];
      }

      return [...queries.allCreateForms({ resource }), "data", locale];
    },
  } as const;
  return queries;
};
